import ManageContentScreen from '../components/ManageContentScreen';

const ManageLibrary = () => {
  return (
    <ManageContentScreen
      type="library"
      title="Manage Sales Tools"
      backPath="/profile"
    />
  );
};

export default ManageLibrary;
